import React from 'react';
import './AboutSection.css';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const AboutSection=()=> {
  const topics=[
    {
      icon: FiIcons.FiTarget,
      title: 'Life & Growth',
      description: 'Stories about discipline,mindset,family,and becoming better than yesterday.'
    },
    {
      icon: FiIcons.FiBriefcase,
      title: 'Business & Brand',
      description: 'Entrepreneurs,creators,and builders—how they started,scaled,and stayed real.'
    },
    {
      icon: FiIcons.FiMic,
      title: 'Culture & Community',
      description: 'Voices from the Bay—music,sport,street to studio—perspective with purpose.'
    }
  ];

  return (
    <section id="about" className="about-section">
      <div className="about-container">
        <div className="about-header">
          <h2 className="about-title">Our Point of View</h2>
        </div>
        <div className="about-content">
          <div className="about-text">
            <p className="about-description">
              Point Makers Podcast was founded in 2024 by brothers Darrence and Demetrius Davis. After producing Treeal Talk 101 with their late cousin Charvel Augustine,they evolved the show's vision — honoring his legacy through meaningful conversations in a professional studio setting.
            </p>
            <div className="about-highlight">
              "Never the ones to be 'Chatty Patty,' we focus on conversation that matters." <br />— The Davis Brothers
            </div>
            <p className="about-description">
              Their mission: spark growth,perspective,and purpose through open,authentic dialogue. From entrepreneurs to entertainers,every guest has a story that sharpens the point.
            </p>
          </div>
          <div className="about-image">
            <img 
              src="https://cloud-1de12d.becdn.net/media/original/b66aaace2d6cc5945b31c30cca95f423.jpg" 
              alt="Point Makers Podcast Studio with Darrence and Demetrius Davis - Professional recording setup" 
              className="hosts-image" 
              loading="lazy" 
            />
          </div>
        </div>
        <div className="topics-section">
          <h3 className="topics-title">What We Talk About</h3>
          <p className="topics-subtitle">Real conversations that enlighten,engage,entertain,and educate.</p>
          <div className="topics-grid">
            {topics.map((topic,index)=> (
              <div key={index} className="topic-card hover-lift">
                <SafeIcon icon={topic.icon} className="topic-icon" />
                <h4 className="topic-title">{topic.title}</h4>
                <p className="topic-description">{topic.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;